import * as React from 'react';

// Components
import Container from '../../components/Container';
import { FixedTopBar } from '../../components/Layout';
import Typography from '../../components/Typography';
import Toolbar from '../../components/Toolbar';

// TODO: fix this hotfix
import NotifcationList from './NotificationList';

// Component
interface IProps {}

class AppNotfications extends React.Component<IProps> {
  render() {
    return (
      <div>
        <FixedTopBar size="md" horizontalPadded={true}>
          <Toolbar>
            <Typography type="title">Notifications</Typography>
          </Toolbar>
        </FixedTopBar>
        <Container size={'md'} padded={true}>
          <NotifcationList />
        </Container>
      </div>
    );
  }
}

export default AppNotfications;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/views/AppNetworkNotifcations/AppNetworkNotfications.tsx